import { compose } from 'redux';
import { connect } from 'react-redux';
import SettingMultiLanguage from '../../../pages/Admin/SettingMultiLanguage/SettingMultiLanguage';
import withAuth from '../../../common/WithAuth';
import { ClearEventZone, GetZonesRequested } from '../../../actions/CommonOptions';
import {
    GetSettingLanguageRequested,
    GetSettingLanguageInit,
    UpdateSettingLanguageRequested,
    UpdateSettingLanguageInit,
} from '../../../actions/SettingMultiLanguage';

const mapStateToProps = (state) => ({
    isLoading: state.settingLanguage.getSettingLanguage.isFetching || state.settingLanguage.updateSettingLanguage.isFetching,
    settingLanguage: state.settingLanguage.getSettingLanguage.data,
    errorsSettingLanguage: state.settingLanguage.getSettingLanguage.errors,
    updateSuccess: state.settingLanguage.updateSettingLanguage.isSuccess,
    errorsUpdate: state.settingLanguage.updateSettingLanguage.errors,
    listZones: state.commonOptions.zones.data,
    listJobsExhibitor: state.eventManagement.infoEvent?.data?.jobs,
    listJobsViewer: state.eventManagement.infoEvent?.data?.jobs_viewer,
    listOccupationViewer: state.eventManagement.infoEvent?.data?.occupations_viewer,
    listOccupationOrganizer: state.eventManagement.infoEvent?.data?.occupations_organizer,
});

const mapDispatchToProps = (dispatch) => ({
    fetchEventZones: (params) => {
        dispatch(GetZonesRequested(params));
    },
    clearEventZone: () => {
        dispatch(ClearEventZone());
    },
    getSettingLanguage: (param) => {
        dispatch(GetSettingLanguageRequested(param));
    },
    clearGetSettingLanguage: () => {
        dispatch(GetSettingLanguageInit());
    },
    updateSettingLanguage: (param) => {
        dispatch(UpdateSettingLanguageRequested(param));
    },
    clearUpdateSettingLanguage: () => {
        dispatch(UpdateSettingLanguageInit());
    },
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(SettingMultiLanguage);
